import { Suspense, useState } from "react";
import {
  BellIcon,
  CloseIcon,
  CountBadge,
  Heading,
  IconButton,
  Tooltip,
} from "@songtradr-one/components-frontend";
import { Flex, NavBarDropdownList } from "@songtradr-one/shared-frontend";
import {
  PanelContainer,
  PanelHeader,
  Props,
  text,
  useNotificationsPanel,
  useNotificationsQueryRef,
} from "./NotificationsPanel.Parts";
import { NotificationsPanelList } from "./notifications-panel-list/NotificationsPanelList";
import { NotificationsPanelListSkeleton } from "./notifications-panel-list/NotificationsPanelList.Skeleton";
import { NotificationsPanelTabs } from "./notifications-panel-tabs/NotificationsPanelTabs";

const NotificationsPanel = ({ queryRef }: Props) => {
  const { unread, open, setOpen, activeTab, setActiveTab } =
    useNotificationsPanel(queryRef);

  const [anchor, setAnchor] = useState<HTMLButtonElement | null>(null);

  return (
    <>
      <Tooltip tip={text.title}>
        <IconButton ref={setAnchor} onClick={() => setOpen((prev) => !prev)}>
          <CountBadge size="small" count={unread}>
            <BellIcon role="img" aria-label="Toggle Notifications" />
          </CountBadge>
        </IconButton>
      </Tooltip>
      <NavBarDropdownList
        anchor={anchor}
        open={open}
        onOpenChange={setOpen}
        offset={12}
        minWidth="28.125rem"
      >
        <PanelContainer>
          <PanelHeader>
            <Flex $justify="space-between" $align="center">
              <Heading variant="h4">{text.title}</Heading>
              <IconButton
                $small
                aria-label={text.close}
                onClick={() => setOpen(false)}
              >
                <CloseIcon height="0.75rem" width="0.75rem" />
              </IconButton>
            </Flex>
            <Flex $justify="space-between" $align="center">
              <NotificationsPanelTabs
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                unread={unread}
              />
            </Flex>
          </PanelHeader>
          <Suspense fallback={<NotificationsPanelListSkeleton />}>
            <NotificationsPanelList
              activeTab={activeTab}
              onNavigate={() => setOpen(false)}
            />
          </Suspense>
        </PanelContainer>
      </NavBarDropdownList>
    </>
  );
};

// WRAPPER
export const NotificationsPanelWrapper = () => {
  const queryRef = useNotificationsQueryRef();

  return (
    <Suspense
      fallback={
        <IconButton disabled>
          <BellIcon role="img" aria-label="Toggle Notifications Fallback" />
        </IconButton>
      }
    >
      <NotificationsPanel queryRef={queryRef} />
    </Suspense>
  );
};
